import { useQuery } from "@tanstack/react-query";
import { fetchInventorySettings } from "../apis/api.inventory";
import { queryInventorySettingsKey } from "../apis/queryKeys";
import { currencySymbol } from "../utils/currencies";

// Config de "Monedas" del owner + helpers derivados (separador, símbolos).
export default function useInventorySettings(ownerId) {
  const query = useQuery({
    queryKey: queryInventorySettingsKey(ownerId),
    queryFn: () => fetchInventorySettings(ownerId),
    enabled: !!ownerId,
  });

  const settings = query.data || null;
  const decimalSeparator = settings?.decimal_separator === "." ? "." : ",";
  const defaultCurrency = settings?.default_currency || null;
  const altCurrency = settings?.alt_currency || null;

  return {
    ...query,
    settings,
    decimalSeparator,
    defaultCurrency,
    altCurrency,
    defaultCurrencySymbol: currencySymbol(defaultCurrency),
    altCurrencySymbol: currencySymbol(altCurrency),
    isConfigured: !!defaultCurrency,
  };
}
